module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/137-fiji-250915676961d9f17ed4346b0dac4454.svg";